import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import ServicesBento from "@/components/home/ServicesBento";
import ConceptShowcase from "@/components/home/ConceptShowcase";
import { Intro, Process, Industries, CtaBand } from "@/components/home/Sections";
import { ROUTE_SEO } from "@/config/seoData";

const Home = () => (
  <>
    <Seo {...ROUTE_SEO.home} />
    <Hero />
    <Marquee />
    <ServicesBento />
    <Intro />
    <ConceptShowcase />
    <Process />
    <Industries />
    <CtaBand />
  </>
);

export default Home;
